import { formatTimestamp } from "../../utils/functions";
import { MUIStyled } from "../MUIStyled";
import SATypography from "../SATypography";

const StyledDate = MUIStyled(SATypography)({
  padding: "4px 8px",
  borderRadius: "6px",
  backgroundColor: "#F3F4F6",
  color: "#374151",
  display: "inline-block",
  fontSize: "0.875rem",
  fontWeight: 500,
});

const SADate = ({ date, showTime = false }) => {
  return (
    <StyledDate variant="body2">
      {date ? formatTimestamp(date, { showTime }) : "-"}
    </StyledDate>
  );
};

export default SADate;
